<template>
  <div class="fSize">
    <!--去用户绑定页面-->
    <van-action-sheet
      safe-area-inset-bottom
      :round="false"
      v-model="showUserAdd"
      title="体检用户绑定"
      :close-on-click-overlay="false"
      @click-overlay="tipsFun"
    >
      <UserAdd @fatherMethod="closeFun"></UserAdd>
    </van-action-sheet>
    <van-cell safe-area-inset-bottom>
      <van-tabs
        v-model="occupatDiseaAll"
        @click="changeTab"
        line-width="1rem"
        sticky
      >
        <van-tab title="基本信息">
          <van-cell-group>
            <van-field
              v-model="occupatDisea.companyCode"
              placeholder="请输入单位编码"
              label="单位编码"
              input-align="right"
              label-width="35%"
              clearable
              required
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.username"
              placeholder="请输入用户姓名"
              label="用户姓名"
              input-align="right"
              label-width="35%"
              clearable
              required
            />
          </van-cell-group>
          <van-field name="radio" label="用户性别" label-width="46%" required>
            <template #input>
              <van-radio-group
                v-model="occupatDisea.sex"
                direction="horizontal"
              >
                <van-radio name="1">男性</van-radio>
                <van-radio name="0">女性</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.cardNumber"
              placeholder="请输入身份证号码"
              label="身份证号码"
              input-align="right"
              label-width="35%"
              clearable
              required
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              name="maritalStatus"
              label-width="35%"
              required
              readonly
              clickable
              :value="columnsText[occupatDisea.maritalStatus]"
              label="婚姻状况"
              placeholder="点击婚姻状况"
              @click="showPicker5 = true"
              input-align="right"
            />
            <van-popup v-model="showPicker5" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns1"
                @confirm="onConfirmMaritalStatus"
                @cancel="showPicker5 = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              name="onJob"
              label-width="35%"
              required
              readonly
              clickable
              :value="columnsText1[occupatDisea.onJob]"
              label="在岗情况"
              placeholder="点击在岗情况"
              @click="showPicker6 = true"
              input-align="right"
            />
            <van-popup v-model="showPicker6" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns2"
                @confirm="onConfirmOnJob"
                @cancel="showPicker6 = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.totalYear"
              placeholder="请输入总工龄年数"
              label="总工龄(年数)"
              input-align="right"
              label-width="35%"
              clearable
              type="digit"
            />
            <van-field
              v-model="occupatDisea.totalMonth"
              placeholder="请输入总工龄月数"
              label="总工龄(月数)"
              input-align="right"
              label-width="35%"
              clearable
              type="digit"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.damageYear"
              placeholder="请输入接害工龄年数"
              label="接害工龄(年数)"
              input-align="right"
              label-width="35%"
              clearable
              type="digit"
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.damageMonth"
              placeholder="请输入接害工龄月数"
              label="接害工龄(月数)"
              input-align="right"
              label-width="35%"
              clearable
              type="digit"
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.typeAndName"
              placeholder="请输入危害种类和名称"
              label="接触职业病危害种类和名称"
              input-align="right"
              rows="2"
              autosize
              type="textarea"
              label-width="35%"
              clearable
              required
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.anamnesis"
              placeholder="请输入既往病史"
              label="既往病史"
              input-align="right"
              rows="2"
              autosize
              type="textarea"
              label-width="35%"
              clearable
              required
            >
            </van-field>
          </van-cell-group>
        </van-tab>
        <van-tab title="职业史">
          <van-cell>
            <van-button
              size="normal"
              round
              block
              type="primary"
              @click="
                isShow = true;
                occupatHist = {};
              "
            >
              添 加 职 业 信 息
            </van-button>
          </van-cell>
          <!-- <van-cell is-link @click="isShow = true">添加职业信息</van-cell> -->
          <van-popup v-model="isShow" closeable position="top">
            <van-cell>
              <van-cell-group>
                <van-field
                  required
                  readonly
                  clickable
                  name="datetimePicker"
                  :value="occupatHist.startDate"
                  label="开始日期"
                  placeholder="点击开始日期"
                  @click="showPicker1 = true"
                  input-align="right"
                />
                <van-popup v-model="showPicker1" position="bottom">
                  <van-datetime-picker
                    type="date"
                    @confirm="onConfirmStartDate"
                    @cancel="showPicker1 = false"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                  />
                </van-popup>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  readonly
                  clickable
                  name="datetimePicker"
                  :value="occupatHist.endDate"
                  label="截止日期"
                  placeholder="点击截止日期"
                  @click="showPicker2 = true"
                  input-align="right"
                />
                <van-popup v-model="showPicker2" position="bottom">
                  <van-datetime-picker
                    type="date"
                    @confirm="onConfirmEndDate"
                    @cancel="showPicker2 = false"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                  />
                </van-popup>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="occupatHist.company"
                  placeholder="请输入工作单位"
                  label="工作单位"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="occupatHist.workshop"
                  placeholder="请输入车间"
                  label="车间"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="occupatHist.profession"
                  placeholder="请输入工种"
                  label="工种"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="occupatHist.harmfulFactor"
                  placeholder="请输入有害因素"
                  label="有害因素"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="occupatHist.safeguardProce"
                  placeholder="请输入防护措施"
                  label="防护措施"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-button
                  text="保 存"
                  round
                  type="info"
                  @click="saveOccHis"
                  style="width: 50%"
                  size="small"
                />
                <van-button
                  text="重 置"
                  type="danger"
                  round
                  style="width: 50%"
                  @click="clearHisData"
                  size="small"
                />
              </van-cell-group>
            </van-cell>
          </van-popup>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
          >
            <van-cell v-for="(item, index) in occupatHistArr" :key="index">
              <p style="text-align: center">
                --------------------职业信息--------------------
              </p>
              <van-cell-group>
                <van-field
                  required
                  readonly
                  clickable
                  :value="occupatHistArr[index].startDate"
                  name="datetimePicker"
                  label="开始日期"
                  placeholder="点击开始日期"
                  @click="getStartDateIndex(index)"
                  input-align="right"
                />
                <van-popup v-model="showPicker3" position="bottom">
                  <van-datetime-picker
                    type="date"
                    @confirm="onConfirmStartDate1"
                    @cancel="showPicker3 = false"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                  />
                </van-popup>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  readonly
                  clickable
                  name="datetimePicker"
                  :value="occupatHistArr[index].endDate"
                  label="截止日期"
                  placeholder="点击截止日期"
                  @click="getEndDateIndex(index)"
                  input-align="right"
                />
                <van-popup v-model="showPicker4" position="bottom">
                  <van-datetime-picker
                    type="date"
                    @confirm="onConfirmEndDate1"
                    @cancel="showPicker4 = false"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                  />
                </van-popup>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="item.company"
                  placeholder="请输入工作单位"
                  label="工作单位"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="item.workshop"
                  placeholder="请输入车间"
                  label="车间"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="item.profession"
                  placeholder="请输入工种"
                  label="工种"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="item.harmfulFactor"
                  placeholder="请输入有害因素"
                  label="有害因素"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
              <van-cell-group>
                <van-field
                  required
                  clearable
                  v-model="item.safeguardProce"
                  placeholder="请输入防护措施"
                  label="防护措施"
                  input-align="right"
                >
                </van-field>
              </van-cell-group>
            </van-cell>
          </van-list>
        </van-tab>
        <van-tab title="现病史">
          <van-field name="radio" label="1、活动性肺结核" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.hdxfjh"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="2、慢性阻塞性肺病" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.mxzsxfb"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="3、慢性间质性肺病" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.mxjzxfb"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="4、伴肺功能损害疾病" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.bfgnshjb"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="5、贫血" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.anemia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="6、卟咻病" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.bxb"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="7、多发性周围神经病" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.dfxzwsjb"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label="8、慢性肾小管-间质性肾病"
            label-width="40%"
          >
            <template #input>
              <van-radio-group
                v-model="occupatDisea.mxsxgjzxsb"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="9、支气管哮喘" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.zqgxc"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label="10、原发性骨质疏松症"
            label-width="40%"
          >
            <template #input>
              <van-radio-group
                v-model="occupatDisea.yfxgzssz"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="11、血常规异常" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.xcgyc"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="12、造血系统疾病" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.zxxtjb"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="13、脾功能亢进" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.pgnkj"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="14、糖尿病" label-width="40%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.diabetes"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.curOtherDisea"
              placeholder="请输入其他病症"
              label="15、其他病症"
              label-width="50%"
              input-align="right"
              rows="2"
              autosize
              type="textarea"
            >
            </van-field>
          </van-cell-group>
        </van-tab>
        <van-tab title="急慢性职业病史" tab-width="1000px">
          <van-cell-group>
            <van-field
              v-model="occupatDisea.jmxzybm"
              placeholder="请输入病名"
              label="病名"
              label-width="50%"
              input-align="right"
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              readonly
              clickable
              name="datetimePicker"
              :value="occupatDisea.diagnoseDate"
              label="诊断日期"
              label-width="50%"
              placeholder="点击诊断日期"
              @click="showPicker = true"
              input-align="right"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-datetime-picker
                type="date"
                @confirm="onConfirm"
                @cancel="showPicker = false"
                v-model="currentDate"
                :min-date="minDate"
                :max-date="maxDate"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.diagnoseCompany"
              placeholder="请输入诊断单位"
              label="诊断单位"
              label-width="50%"
              input-align="right"
            >
            </van-field>
          </van-cell-group>
          <van-field name="radio" label="是否痊愈" label-width="55%">
            <template #input>
              <van-radio-group
                v-model="occupatDisea.isCure"
                direction="horizontal"
              >
                <van-radio name="1">是</van-radio>
                <van-radio name="2">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-tab>
        <van-tab
          title="月经史"
          v-show="false"
          :disabled="occupatDisea.sex == '1' ? true : false"
        >
          <van-cell-group>
            <van-field
              required
              clearable
              v-model="occupatDisea.menstrHistory"
              placeholder="请输入初潮"
              label="初潮"
              label-width="40%"
              input-align="right"
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              required
              clearable
              v-model="occupatDisea.menstrCycle"
              placeholder="请输入周期"
              label="周期"
              label-width="40%"
              input-align="right"
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              required
              clearable
              v-model="occupatDisea.menstrPeriod"
              placeholder="请输入经期"
              label="经期"
              label-width="40%"
              input-align="right"
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              required
              clearable
              v-model="occupatDisea.menopausaAge"
              placeholder="请输入停经年龄"
              label="停经年龄"
              label-width="40%"
              input-align="right"
            >
            </van-field>
          </van-cell-group>
        </van-tab>
        <van-tab title="生育史" tab-width="1000px">
          <van-cell-group>
            <van-field
              v-model="occupatDisea.childbearHist"
              placeholder="请输入现有子女人数"
              label="现有子女人数"
              label-width="40%"
              input-align="right"
              clearable
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.alcoTobaHist"
              placeholder="请输入流产次数"
              label="流产次数"
              label-width="40%"
              input-align="right"
              clearable
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.zccs"
              placeholder="请输入早产次数"
              label="早产次数"
              label-width="40%"
              input-align="right"
              clearable
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.sccs"
              placeholder="请输入死产次数"
              label="死产次数"
              label-width="40%"
              input-align="right"
              clearable
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.yctcs"
              placeholder="请输入异常胎次数"
              label="异常胎次数"
              label-width="40%"
              input-align="right"
              clearable
            >
            </van-field>
          </van-cell-group>
        </van-tab>
        <van-tab title="烟酒史" tab-width="1000px">
          <van-field name="radio" label-width="27%" label="吸烟频次" required>
            <template #input>
              <van-radio-group
                v-model="occupatDisea.xypc"
                direction="horizontal"
              >
                <van-radio name="1">不吸</van-radio>
                <van-radio name="2">偶吸</van-radio>
                <van-radio name="3">经常</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.xymtbs"
              placeholder="请输入吸烟每天包数"
              label="吸烟每天包数"
              label-width="30%"
              input-align="right"
              required
              clearable
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.xyns"
              placeholder="请输入吸烟总年数"
              label="吸烟总年数"
              label-width="30%"
              input-align="right"
              required
              clearable
            >
            </van-field>
          </van-cell-group>
          <van-field name="radio" label-width="27%" label="喝酒频次" required>
            <template #input>
              <van-radio-group
                v-model="occupatDisea.hjpc"
                direction="horizontal"
              >
                <van-radio name="1">不饮</van-radio>
                <van-radio name="2">偶饮</van-radio>
                <van-radio name="3">经常</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.hjmtmls"
              placeholder="请输入喝酒每天ml数"
              label="喝酒每天ml数"
              label-width="30%"
              input-align="right"
              required
              clearable
            >
            </van-field>
          </van-cell-group>
          <van-cell-group>
            <van-field
              v-model="occupatDisea.hjns"
              placeholder="请输入喝酒总年数"
              label="喝酒总年数"
              label-width="30%"
              input-align="right"
              required
              clearable
            >
            </van-field>
          </van-cell-group>
        </van-tab>
        <van-tab title="职业病症状">
          <van-field name="radio" label-width="38%" required label="1、头痛">
            <template #input>
              <van-radio-group
                v-model="symptom.headache"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="2、头(晕)昏"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.dizziness"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="3、眩晕">
            <template #input>
              <van-radio-group v-model="symptom.swirl" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="4、失眠">
            <template #input>
              <van-radio-group
                v-model="symptom.insomnia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="5、嗜睡">
            <template #input>
              <van-radio-group
                v-model="symptom.somnolence"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="6、多梦">
            <template #input>
              <van-radio-group
                v-model="symptom.dreaminess"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="7、记忆力减退"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.hypomnesis"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="8、易激动">
            <template #input>
              <van-radio-group
                v-model="symptom.excitable"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="9、疲乏无力"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.tiredness"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="10、低热">
            <template #input>
              <van-radio-group
                v-model="symptom.lowGradeFever"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="11、盗汗">
            <template #input>
              <van-radio-group
                v-model="symptom.nightSweat"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="12、多汗">
            <template #input>
              <van-radio-group
                v-model="symptom.hidrosis"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="13、全身酸痛"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.bodyAchesPains"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="14、性欲减退"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.hyposexuality"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="15、视物模糊"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.blurredVision"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="16、视力下降"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.diminutionVision"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="17、眼痛">
            <template #input>
              <van-radio-group
                v-model="symptom.ophthalmodynia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="18、羞明">
            <template #input>
              <van-radio-group
                v-model="symptom.photophobia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="19、流泪">
            <template #input>
              <van-radio-group
                v-model="symptom.lacrimation"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="20、嗅觉减退"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.hyposmia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="21、鼻干">
            <template #input>
              <van-radio-group
                v-model="symptom.nasalCavityDry"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="22、鼻堵">
            <template #input>
              <van-radio-group
                v-model="symptom.rhinostegnosis"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="23、流鼻血">
            <template #input>
              <van-radio-group
                v-model="symptom.nosebleed"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="24、流涕">
            <template #input>
              <van-radio-group
                v-model="symptom.runnyNose"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="25、耳鸣">
            <template #input>
              <van-radio-group
                v-model="symptom.tinnitus"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="26、耳聋">
            <template #input>
              <van-radio-group
                v-model="symptom.epicophosis"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="27、口渴">
            <template #input>
              <van-radio-group v-model="symptom.thirst" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="28、流涎">
            <template #input>
              <van-radio-group
                v-model="symptom.salivation"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="29、牙痛">
            <template #input>
              <van-radio-group
                v-model="symptom.toothache"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="30、牙齿松动"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.odontoseisis"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="31、刷牙出血"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.brushTeethBleed"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="32、口腔异味"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.badBreath"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="33、口腔溃疡"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.oralUlcer"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="34、咽痛">
            <template #input>
              <van-radio-group
                v-model="symptom.pharyngalgia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="35、气短">
            <template #input>
              <van-radio-group v-model="symptom.pant" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="36、胸闷">
            <template #input>
              <van-radio-group
                v-model="symptom.chestDistress"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="37、胸痛">
            <template #input>
              <van-radio-group
                v-model="symptom.thoracalgia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="38、咳嗽">
            <template #input>
              <van-radio-group v-model="symptom.cough" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="39、咳痰">
            <template #input>
              <van-radio-group
                v-model="symptom.expectoration"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="40、咯血">
            <template #input>
              <van-radio-group
                v-model="symptom.hemoptysis"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="41、哮喘">
            <template #input>
              <van-radio-group v-model="symptom.asthma" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="42、心悸">
            <template #input>
              <van-radio-group
                v-model="symptom.palpitation"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="43、心前区不适"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.precordDiscomf"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="44、食欲减退"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.anorexia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="45、消瘦">
            <template #input>
              <van-radio-group
                v-model="symptom.emaciation"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="46、恶心">
            <template #input>
              <van-radio-group v-model="symptom.nausea" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="47、呕吐">
            <template #input>
              <van-radio-group v-model="symptom.emesis" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="48、腹胀">
            <template #input>
              <van-radio-group
                v-model="symptom.ventosity"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="49、腹痛">
            <template #input>
              <van-radio-group
                v-model="symptom.stomachache"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="50、肝区痛">
            <template #input>
              <van-radio-group
                v-model="symptom.liverAreaPain"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="51、腹泻">
            <template #input>
              <van-radio-group
                v-model="symptom.diarrhea"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="52、便秘">
            <template #input>
              <van-radio-group
                v-model="symptom.constipation"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="53、尿频">
            <template #input>
              <van-radio-group
                v-model="symptom.frequentMictur"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="54、尿急">
            <template #input>
              <van-radio-group
                v-model="symptom.urgentUrinat"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="55、尿血">
            <template #input>
              <van-radio-group
                v-model="symptom.hematuria"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="56、皮下出血"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.subcutHemor"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="57、皮肤瘙痒"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.skinItch"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="58、皮疹">
            <template #input>
              <van-radio-group v-model="symptom.rash" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="59、浮肿">
            <template #input>
              <van-radio-group v-model="symptom.edema" direction="horizontal">
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="60、脱发">
            <template #input>
              <van-radio-group
                v-model="symptom.alopecia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label-width="38%" required label="61、关节痛">
            <template #input>
              <van-radio-group
                v-model="symptom.arthralgia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="62、四肢麻木"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.limbsAnesthesia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="63、运作不灵活"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.inflexibleOpera"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="radio"
            label-width="38%"
            required
            label="64、月经异常"
            :class="occupatDisea.sex === '1' ? 'display1' : ''"
          >
            <template #input>
              <van-radio-group
                v-model="symptom.menoxenia"
                direction="horizontal"
              >
                <van-radio name="1">有症状</van-radio>
                <van-radio name="2">无症状</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-tab>
      </van-tabs>
      <br /><br />
    </van-cell>
    <van-cell class="buttonFixed" safe-area-inset-bottom>
      <van-button
        text="保 存"
        round
        type="info"
        @click="submitFun()"
        style="width: 50%"
      />
      <van-button
        text="重 置"
        type="danger"
        round
        style="width: 50%"
        @click="clearData()"
      />
    </van-cell>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  Row,
  Col,
  Button,
  Dialog,
  Toast,
  ActionSheet,
  Icon,
  Image as VanImage,
  Empty,
  Field,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Picker,
} from "vant";
import { getAll, addAll } from "@/api/common";
import UserAdd from "@/components/UserAdd";
import { getUser } from "@/api/user";

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [ActionSheet.name]: ActionSheet,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Empty.name]: Empty,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    UserAdd,
  },
  data() {
    return {
      histIndex1: null,
      histIndex2: null,
      isShow: false,
      occupatHistArr: [],
      date1: "",
      date2: "",
      date3: "",
      showPicker1: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      showPicker5: false,
      showPicker6: false,
      showPicker: false,
      chosenContactId: "1",
      symptom: {},
      occupatDisea: {},
      radio: "1",
      error: false,
      errorText: "请求失败，点击重新加载",
      loading: false,
      finished: false,
      refreshing: false,
      showBase: false,
      detail: null,
      showEmpty: false,
      occupatHist: {},
      occupatDiseaAll: {},
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2500, 10, 1),
      currentDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      columns1: [
        { text: "未婚", value: "0" },
        { text: "已婚", value: "1" },
        { text: "离异", value: "2" },
        { text: "丧偶", value: "W" },
      ],
      columns2: [
        { text: "上岗前", value: "1" },
        { text: "离岗时", value: "2" },
        { text: "在岗期间", value: "3" },
        { text: "离岗后", value: "4" },
        { text: "应急健康检查", value: "5" },
      ],
      columnsText: { 0: "未婚", 1: "已婚", 2: "离异", W: "丧偶" },
      columnsText1: {
        1: "上岗前",
        2: "离岗时",
        3: "在岗期间",
        4: "离岗后",
        5: "应急健康检查",
      },
      occupatDisea: {
        hdxfjh: "2",
        mxzsxfb: "2",
        mxjzxfb: "2",
        bfgnshjb: "2",
        anemia: "2",
        bxb: "2",
        dfxzwsjb: "2",
        mxsxgjzxsb: "2",
        zqgxc: "2",
        yfxgzssz: "2",
        xcgyc: "2",
        zxxtjb: "2",
        pgnkj: "2",
        diabetes: "2",
      },
      symptom: {
        headache: "2",
        dizziness: "2",
        swirl: "2",
        insomnia: "2",
        somnolence: "2",
        dreaminess: "2",
        hypomnesis: "2",
        excitable: "2",
        tiredness: "2",
        lowGradeFever: "2",
        nightSweat: "2",
        hidrosis: "2",
        bodyAchesPains: "2",
        hyposexuality: "2",
        blurredVision: "2",
        diminutionVision: "2",
        ophthalmodynia: "2",
        photophobia: "2",
        lacrimation: "2",
        hyposmia: "2",
        nasalCavityDry: "2",
        rhinostegnosis: "2",
        nosebleed: "2",
        runnyNose: "2",
        tinnitus: "2",
        epicophosis: "2",
        thirst: "2",
        salivation: "2",
        toothache: "2",
        odontoseisis: "2",
        brushTeethBleed: "2",
        badBreath: "2",
        oralUlcer: "2",
        pharyngalgia: "2",
        pant: "2",
        chestDistress: "2",
        thoracalgia: "2",
        cough: "2",
        expectoration: "2",
        hemoptysis: "2",
        asthma: "2",
        palpitation: "2",
        precordDiscomf: "2",
        anorexia: "2",
        emaciation: "2",
        nausea: "2",
        emesis: "2",
        ventosity: "2",
        stomachache: "2",
        liverAreaPain: "2",
        diarrhea: "2",
        constipation: "2",
        frequentMictur: "2",
        urgentUrinat: "2",
        hematuria: "2",
        subcutHemor: "2",
        skinItch: "2",
        rash: "2",
        edema: "2",
        alopecia: "2",
        arthralgia: "2",
        limbsAnesthesia: "2",
        inflexibleOpera: "2",
        menoxenia: "2",
      },
      showUserAdd: false,
    };
  },
  created() {
    const that = this;
    if (sessionStorage.getItem("userIsBang") !== "yes") {
      Toast("请先绑定用户信息...");
      //如果用户信息为空则去设置用户
      that.showUserAdd = true;
      return false;
    } else {
      that.gainUser();
    }
  },
  mounted() {
    const that = this;
    that.getAll();
    window.history.pushState(null, null, "#");
    window.addEventListener(
      "popstate",
      function (e) {
        WeixinJSBridge.call("closeWindow");
      },
      false
    );
  },
  methods: {
    Dialog() {
      const that = this;
      that.$dialog
        .confirm({
          title: "标题2",
          message: "弹框内容2",
          confirmButtonColor: "red",
        })
        .then(() => {
          console.log("点击了确认");
        })
        .catch(() => {
          console.log("点击了取消");
        });
    },
    cancle() {
      const that = this;
      that.showPicker = false;
    },
    onConfirm(date) {
      const that = this;
      that.occupatDisea.diagnoseDate = that.formatTime(date);
      that.showPicker = false;
    },
    onConfirmStartDate(date) {
      const that = this;
      that.occupatHist.startDate = that.formatTime(date);
      that.showPicker1 = false;
    },
    onConfirmEndDate(date) {
      const that = this;
      that.occupatHist.endDate = that.formatTime(date);
      that.showPicker2 = false;
    },
    onConfirmStartDate1(date) {
      const that = this;
      that.occupatHistArr[that.histIndex1].startDate = that.formatTime(date);
      that.showPicker3 = false;
    },
    onConfirmEndDate1(date) {
      const that = this;
      that.occupatHistArr[that.histIndex2].endDate = that.formatTime(date);
      that.showPicker4 = false;
    },
    // 确认婚姻状况
    onConfirmMaritalStatus(value) {
      const that = this;
      that.occupatDisea.maritalStatus = value.value;
      that.showPicker5 = false;
    },
    // 确认在岗情况
    onConfirmOnJob(value) {
      const that = this;
      that.occupatDisea.onJob = value.value;
      that.showPicker6 = false;
    },
    getStartDateIndex(data) {
      const that = this;
      that.showPicker3 = true;
      that.histIndex1 = data;
    },
    getEndDateIndex(data) {
      const that = this;
      that.showPicker4 = true;
      that.histIndex2 = data;
    },
    //预约信息提交
    saveOccHis() {
      const that = this;
      if (
        that.occupatHist.startDate == null ||
        that.occupatHist.startDate === ""
      ) {
        Toast("【职业信息的开始日期】不能为空...");
        return false;
      }
      if (that.occupatHist.endDate == null || that.occupatHist.endDate === "") {
        Toast("【职业信息的截止日期】不能为空...");
        return false;
      }
      if (that.occupatHist.company == null || that.occupatHist.company === "") {
        Toast("【职业信息的工作单位】不能为空...");
        return false;
      }
      if (
        that.occupatHist.workshop == null ||
        that.occupatHist.workshop === ""
      ) {
        Toast("【职业信息的车间】不能为空...");
        return false;
      }
      if (
        that.occupatHist.profession == null ||
        that.occupatHist.profession === ""
      ) {
        Toast("【职业信息的工种】不能为空...");
        return false;
      }
      if (
        that.occupatHist.harmfulFactor == null ||
        that.occupatHist.harmfulFactor === ""
      ) {
        Toast("【职业信息的有害因素】不能为空...");
        return false;
      }
      if (
        that.occupatHist.safeguardProce == null ||
        that.occupatHist.safeguardProce === ""
      ) {
        Toast("【职业信息的防护措施】不能为空...");
        return false;
      }
      that.occupatHistArr.push(this.occupatHist);
      that.isShow = false;
    },

    //添加页面提交
    submitFun() {
      const that = this;
      if (
        that.occupatDisea.companyCode == null ||
        that.occupatDisea.companyCode === ""
      ) {
        Toast("【单位编码】不能为空...");
        return false;
      }
      if (that.occupatDisea.companyCode.length > 18) {
        Toast("【单位编码】长度不能超过18位...");
        return false;
      }
      if (
        that.occupatDisea.username == null ||
        that.occupatDisea.username === ""
      ) {
        Toast("【用户姓名】不能为空...");
        return false;
      }
      if (that.occupatDisea.sex == null || that.occupatDisea.sex === "") {
        Toast("【用户性别】不能为空...");
        return false;
      }
      if (
        that.occupatDisea.cardNumber == null ||
        that.occupatDisea.cardNumber === "" ||
        !/^\d{17}([0-9]|X)$/.test(that.occupatDisea.cardNumber)
      ) {
        Toast("【身份证号码】不能为空或格式错误...");
        return false;
      }
      if (that.occupatDisea.cardNumber.length !== 18) {
        Toast("【身份证号码】长度为18位...");
        return false;
      }
      if (that.userInfo.cardNumber !== null && that.userInfo.cardNumber !== "") {
        if (that.occupatDisea.cardNumber === that.userInfo.cardNumber) {
          Toast("【您输入的身份证号和注册用户的身份证号不一致...");
          return false;
        }
      }
      if (
        that.occupatDisea.maritalStatus == null ||
        that.occupatDisea.maritalStatus === ""
      ) {
        Toast("【婚姻状况】不能为空...");
        return false;
      }
      if (
        that.occupatDisea.typeAndName == null ||
        that.occupatDisea.typeAndName === ""
      ) {
        Toast("【接触职业病危害种类和名称】不能为空...");
        return false;
      }
      if (
        that.occupatDisea.anamnesis == null ||
        that.occupatDisea.anamnesis === ""
      ) {
        Toast("【既往病史】不能为空...");
        return false;
      }
      var flag = true;
      // 职业信息
      //   for (var i=0;i<that.occupatHistArr.length;i++) {
      //       if (
      //       that.occupatHistArr[i].workshop == null ||
      //       that.occupatHistArr[i].workshop === ""
      //     ) {
      //       Toast("【职业信息的车间】不能为空...");
      //       flag = false;
      //       return false;
      //     }
      //     if (
      //       that.occupatHistArr[i].profession == null ||
      //       that.occupatHistArr[i].profession === ""
      //     ) {
      //       Toast("【职业信息的工种】不能为空...");
      //       flag = false;
      //       return false;
      //     }
      //   }
      that.occupatHistArr.forEach(function (value, index, array) {
        var index1 = index + 1;
        if (value.startDate == null || value.startDate === "") {
          Toast("【第" + index1 + "条职业信息的开始日期】不能为空...");
          flag = false;
          return false;
        }
        if (value.endDate == null || value.endDate === "") {
          Toast("【第" + index1 + "条职业信息的截止日期】不能为空...");
          flag = false;
          return false;
        }
        if (value.company == null || value.company === "") {
          Toast("【第" + index1 + "条职业信息的工作单位】不能为空...");
          flag = false;
          return false;
        }
        if (value.workshop == null || value.workshop === "") {
          Toast("【第" + index1 + "条职业信息的车间】不能为空...");
          flag = false;
          return false;
        }
        if (value.profession == null || value.profession === "") {
          Toast("【第" + index1 + "条职业信息的工种】不能为空...");
          flag = false;
          return false;
        }
        if (value.harmfulFactor == null || value.harmfulFactor === "") {
          Toast("【第" + index1 + "条职业信息的有害因素】不能为空...");
          flag = false;
          return false;
        }
        if (value.safeguardProce == null || value.safeguardProce === "") {
          Toast("【第" + index1 + "条职业信息的防护措施】不能为空...");
          flag = false;
          return false;
        }
      });
      if (!flag) {
        return flag;
      }

      // 月经史
      if (that.occupatDisea.sex === "0") {
        if (
          that.occupatDisea.menstrHistory == null ||
          that.occupatDisea.menstrHistory === ""
        ) {
          Toast("【月经史的初潮】不能为空...");
          return false;
        }
        if (
          that.occupatDisea.menstrCycle == null ||
          that.occupatDisea.menstrCycle === ""
        ) {
          Toast("【月经史的周期】不能为空...");
          return false;
        }
        if (
          that.occupatDisea.menstrPeriod == null ||
          that.occupatDisea.menstrPeriod === ""
        ) {
          Toast("【月经史的经期】不能为空...");
          return false;
        }
        if (
          that.occupatDisea.menopausaAge == null ||
          that.occupatDisea.menopausaAge === ""
        ) {
          Toast("【月经史的停经年龄】不能为空...");
          return false;
        }
      }

      // 生育史
      // if (
      //   that.occupatDisea.childbearHist == null ||
      //   that.occupatDisea.childbearHist === ""
      // ) {
      //   Toast("【生育史的现有子女人数】不能为空...");
      //   return false;
      // }
      // if (
      //   that.occupatDisea.alcoTobaHist == null ||
      //   that.occupatDisea.alcoTobaHist === ""
      // ) {
      //   Toast("【生育史的】不能为空...");
      //   return false;
      // }
      // if (that.occupatDisea.zccs == null || that.occupatDisea.zccs === "") {
      //   Toast("【生育史的早产次数】不能为空...");
      //   return false;
      // }
      // if (that.occupatDisea.sccs == null || that.occupatDisea.sccs === "") {
      //   Toast("【生育史的死产次数】不能为空...");
      //   return false;
      // }
      // if (that.occupatDisea.yctcs == null || that.occupatDisea.yctcs === "") {
      //   Toast("【生育史的异常胎次数】不能为空...");
      //   return false;
      // }

      // 烟酒史
      if (that.occupatDisea.xypc == null || that.occupatDisea.xypc === "") {
        Toast("【烟酒史的吸烟频次】不能为空...");
        return false;
      }
      if (that.occupatDisea.xymtbs == null || that.occupatDisea.xymtbs === "") {
        Toast("【烟酒史的吸烟每天包数】不能为空...");
        return false;
      }
      if (that.occupatDisea.xyns == null || that.occupatDisea.xyns === "") {
        Toast("【烟酒史的吸烟总年数】不能为空...");
        return false;
      }
      if (that.occupatDisea.hjpc == null || that.occupatDisea.hjpc === "") {
        Toast("【烟酒史的喝酒频次】不能为空...");
        return false;
      }
      if (
        that.occupatDisea.hjmtmls == null ||
        that.occupatDisea.hjmtmls === ""
      ) {
        Toast("【烟酒史的喝酒每天ml数】不能为空...");
        return false;
      }
      if (that.occupatDisea.hjns == null || that.occupatDisea.hjns === "") {
        Toast("【烟酒史的喝酒总年数】不能为空...");
        return false;
      }

      // 职业病症状
      if (that.symptom.headache == null || that.symptom.xypc === "") {
        Toast("【职业病症状的头痛】不能为空...");
        return false;
      }
      if (that.symptom.dizziness == null || that.symptom.dizziness === "") {
        Toast("【职业病症状的头(晕)昏】不能为空...");
        return false;
      }
      if (that.symptom.swirl == null || that.symptom.swirl === "") {
        Toast("【职业病症状的眩晕】不能为空...");
        return false;
      }
      if (that.symptom.insomnia == null || that.symptom.insomnia === "") {
        Toast("【职业病症状的失眠】不能为空...");
        return false;
      }
      if (that.symptom.somnolence == null || that.symptom.somnolence === "") {
        Toast("【职业病症状的嗜睡】不能为空...");
        return false;
      }
      if (that.symptom.dreaminess == null || that.symptom.dreaminess === "") {
        Toast("【职业病症状的多梦】不能为空...");
        return false;
      }
      if (that.symptom.hypomnesis == null || that.symptom.hypomnesis === "") {
        Toast("【职业病症状的记忆力减退】不能为空...");
        return false;
      }
      if (that.symptom.excitable == null || that.symptom.excitable === "") {
        Toast("【职业病症状的易激动】不能为空...");
        return false;
      }
      if (that.symptom.tiredness == null || that.symptom.tiredness === "") {
        Toast("【职业病症状的疲乏无力】不能为空...");
        return false;
      }
      if (
        that.symptom.lowGradeFever == null ||
        that.symptom.lowGradeFever === ""
      ) {
        Toast("【职业病症状的低热】不能为空...");
        return false;
      }
      if (that.symptom.nightSweat == null || that.symptom.nightSweat === "") {
        Toast("【职业病症状的盗汗】不能为空...");
        return false;
      }
      if (that.symptom.hidrosis == null || that.symptom.hidrosis === "") {
        Toast("【职业病症状的多汗】不能为空...");
        return false;
      }
      if (
        that.symptom.bodyAchesPains == null ||
        that.symptom.bodyAchesPains === ""
      ) {
        Toast("【职业病症状的全身酸痛】不能为空...");
        return false;
      }
      if (
        that.symptom.hyposexuality == null ||
        that.symptom.hyposexuality === ""
      ) {
        Toast("【职业病症状的性欲减退】不能为空...");
        return false;
      }
      if (
        that.symptom.blurredVision == null ||
        that.symptom.blurredVision === ""
      ) {
        Toast("【职业病症状的视物模糊】不能为空...");
        return false;
      }
      if (
        that.symptom.diminutionVision == null ||
        that.symptom.diminutionVision === ""
      ) {
        Toast("【职业病症状的视力下降】不能为空...");
        return false;
      }
      if (
        that.symptom.ophthalmodynia == null ||
        that.symptom.ophthalmodynia === ""
      ) {
        Toast("【职业病症状的眼痛】不能为空...");
        return false;
      }
      if (that.symptom.photophobia == null || that.symptom.photophobia === "") {
        Toast("【职业病症状的羞明】不能为空...");
        return false;
      }
      if (that.symptom.lacrimation == null || that.symptom.lacrimation === "") {
        Toast("【职业病症状的流泪】不能为空...");
        return false;
      }
      if (that.symptom.hyposmia == null || that.symptom.hyposmia === "") {
        Toast("【职业病症状的嗅觉减退】不能为空...");
        return false;
      }
      if (
        that.symptom.nasalCavityDry == null ||
        that.symptom.nasalCavityDry === ""
      ) {
        Toast("【职业病症状的鼻干】不能为空...");
        return false;
      }
      if (
        that.symptom.rhinostegnosis == null ||
        that.symptom.rhinostegnosis === ""
      ) {
        Toast("【职业病症状的鼻堵】不能为空...");
        return false;
      }
      if (that.symptom.nosebleed == null || that.symptom.nosebleed === "") {
        Toast("【职业病症状的流鼻血】不能为空...");
        return false;
      }
      if (that.symptom.runnyNose == null || that.symptom.runnyNose === "") {
        Toast("【职业病症状的流涕】不能为空...");
        return false;
      }
      if (that.symptom.tinnitus == null || that.symptom.tinnitus === "") {
        Toast("【职业病症状的耳鸣】不能为空...");
        return false;
      }
      if (that.symptom.epicophosis == null || that.symptom.epicophosis === "") {
        Toast("【职业病症状的耳聋】不能为空...");
        return false;
      }
      if (that.symptom.thirst == null || that.symptom.thirst === "") {
        Toast("【职业病症状的口渴】不能为空...");
        return false;
      }
      if (that.symptom.salivation == null || that.symptom.salivation === "") {
        Toast("【职业病症状的流涎】不能为空...");
        return false;
      }
      if (that.symptom.toothache == null || that.symptom.toothache === "") {
        Toast("【职业病症状的牙痛】不能为空...");
        return false;
      }
      if (
        that.symptom.odontoseisis == null ||
        that.symptom.odontoseisis === ""
      ) {
        Toast("【职业病症状的牙齿松动】不能为空...");
        return false;
      }
      if (
        that.symptom.brushTeethBleed == null ||
        that.symptom.brushTeethBleed === ""
      ) {
        Toast("【职业病症状的刷牙出血】不能为空...");
        return false;
      }
      if (that.symptom.badBreath == null || that.symptom.badBreath === "") {
        Toast("【职业病症状的口腔异味】不能为空...");
        return false;
      }
      if (that.symptom.oralUlcer == null || that.symptom.oralUlcer === "") {
        Toast("【职业病症状的口腔溃疡】不能为空...");
        return false;
      }
      if (
        that.symptom.pharyngalgia == null ||
        that.symptom.pharyngalgia === ""
      ) {
        Toast("【职业病症状的咽痛】不能为空...");
        return false;
      }
      if (that.symptom.pant == null || that.symptom.pant === "") {
        Toast("【职业病症状的气短】不能为空...");
        return false;
      }
      if (
        that.symptom.chestDistress == null ||
        that.symptom.chestDistress === ""
      ) {
        Toast("【职业病症状的胸闷】不能为空...");
        return false;
      }
      if (that.symptom.thoracalgia == null || that.symptom.thoracalgia === "") {
        Toast("【职业病症状的胸痛】不能为空...");
        return false;
      }
      if (that.symptom.cough == null || that.symptom.cough === "") {
        Toast("【职业病症状的咳嗽】不能为空...");
        return false;
      }
      if (
        that.symptom.expectoration == null ||
        that.symptom.expectoration === ""
      ) {
        Toast("【职业病症状的咳痰】不能为空...");
        return false;
      }
      if (that.symptom.hemoptysis == null || that.symptom.hemoptysis === "") {
        Toast("【职业病症状的咯血】不能为空...");
        return false;
      }
      if (that.symptom.asthma == null || that.symptom.asthma === "") {
        Toast("【职业病症状的哮喘】不能为空...");
        return false;
      }
      if (that.symptom.palpitation == null || that.symptom.palpitation === "") {
        Toast("【职业病症状的心悸】不能为空...");
        return false;
      }
      if (
        that.symptom.precordDiscomf == null ||
        that.symptom.precordDiscomf === ""
      ) {
        Toast("【职业病症状的心前区不适】不能为空...");
        return false;
      }
      if (that.symptom.anorexia == null || that.symptom.anorexia === "") {
        Toast("【职业病症状的食欲减退】不能为空...");
        return false;
      }
      if (that.symptom.emaciation == null || that.symptom.emaciation === "") {
        Toast("【职业病症状的消瘦】不能为空...");
        return false;
      }
      if (that.symptom.nausea == null || that.symptom.nausea === "") {
        Toast("【职业病症状的恶心】不能为空...");
        return false;
      }
      if (that.symptom.emesis == null || that.symptom.emesis === "") {
        Toast("【职业病症状的呕吐】不能为空...");
        return false;
      }
      if (that.symptom.ventosity == null || that.symptom.ventosity === "") {
        Toast("【职业病症状的腹胀】不能为空...");
        return false;
      }
      if (that.symptom.stomachache == null || that.symptom.stomachache === "") {
        Toast("【职业病症状的腹痛】不能为空...");
        return false;
      }
      if (
        that.symptom.liverAreaPain == null ||
        that.symptom.liverAreaPain === ""
      ) {
        Toast("【职业病症状的肝区痛】不能为空...");
        return false;
      }
      if (that.symptom.diarrhea == null || that.symptom.diarrhea === "") {
        Toast("【职业病症状的腹泻】不能为空...");
        return false;
      }
      if (
        that.symptom.constipation == null ||
        that.symptom.constipation === ""
      ) {
        Toast("【职业病症状的便秘】不能为空...");
        return false;
      }
      if (
        that.symptom.frequentMictur == null ||
        that.symptom.frequentMictur === ""
      ) {
        Toast("【职业病症状的尿频】不能为空...");
        return false;
      }
      if (
        that.symptom.urgentUrinat == null ||
        that.symptom.urgentUrinat === ""
      ) {
        Toast("【职业病症状的尿急】不能为空...");
        return false;
      }
      if (that.symptom.hematuria == null || that.symptom.hematuria === "") {
        Toast("【职业病症状的尿血】不能为空...");
        return false;
      }
      if (that.symptom.subcutHemor == null || that.symptom.subcutHemor === "") {
        Toast("【职业病症状的皮下出血】不能为空...");
        return false;
      }
      if (that.symptom.skinItch == null || that.symptom.skinItch === "") {
        Toast("【职业病症状的皮肤瘙痒】不能为空...");
        return false;
      }
      if (that.symptom.rash == null || that.symptom.rash === "") {
        Toast("【职业病症状的皮疹】不能为空...");
        return false;
      }
      if (that.symptom.edema == null || that.symptom.edema === "") {
        Toast("【职业病症状的浮肿】不能为空...");
        return false;
      }
      if (that.symptom.alopecia == null || that.symptom.alopecia === "") {
        Toast("【职业病症状的脱发】不能为空...");
        return false;
      }
      if (that.symptom.arthralgia == null || that.symptom.arthralgia === "") {
        Toast("【职业病症状的关节痛】不能为空...");
        return false;
      }
      if (
        that.symptom.limbsAnesthesia == null ||
        that.symptom.limbsAnesthesia === ""
      ) {
        Toast("【职业病症状的四肢麻木】不能为空...");
        return false;
      }
      if (
        that.symptom.inflexibleOpera == null ||
        that.symptom.inflexibleOpera === ""
      ) {
        Toast("【职业病症状的运作不灵活】不能为空...");
        return false;
      }
      if (that.occupatDisea.sex === "0") {
        if (that.symptom.menoxenia == null || that.symptom.menoxenia === "") {
          Toast("【职业病症状的月经异常】不能为空...");
          return false;
        }
      }
      that.occupatDisea.openId =
        sessionStorage.getItem("openid") || "oQv646by-HepzFd0hqcuIxqTtr20";
      //按钮相关操作
      that.submitText = "提交中...";
      that.submitShow = true;
      //请求方法
      let occuDiseaseAll = {
        occDis: that.occupatDisea,
        occHis: that.occupatHistArr,
        occSym: that.symptom,
      };
      addAll(occuDiseaseAll)
        .then((resp) => {
          if (resp.code === 200) {
            Toast({
              type: "success",
              message: "添加成功...",
              duration: 2000,
            });
          } else {
            Toast({
              type: "fail",
              message: resp.msg,
            });
          }
          setTimeout(function () {
            that.submitText = "提交";
            that.submitShow = false;
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //时间格式化
    formatTime(date, split = "-") {
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      //let hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
      //let minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
      //let second = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
      //return year + "-" + month + "-" + day + " " + hour + ":" + minute;
      //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
      return year + split + month + split + day;
    },
    //条件重置
    clearData() {
      const that = this;
      that.occupatDisea = {};
      that.symptom = {};
      that.occupatHistArr = [];
    },
    clearHisData() {
      const that = this;
      that.occupatHist = {};
    },
    //标签栏切换
    changeTab(e) {
      const that = this;
      // this.reset();
      // this.getList();
    },
    //下拉刷新
    onRefresh() {
      const that = this;
      // 清空列表数据
      // that.reset();
      that.refreshing = false;
      // 重新加载数据
      that.getList();
    },
    onLoad() {
      const that = this;
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        that.loading = false;
        // 数据全部加载完成
        that.finished = true;
      }, 1000);
    },

    getAll() {
      const that = this;
      getAll(sessionStorage.getItem("openid") || "oQv646by-HepzFd0hqcuIxqTtr20")
        .then((resp) => {
          if (resp.code === 200) {
            if (resp.data !== null) {
              that.occupatDisea = resp.data.occDis;
              that.occupatHistArr = resp.data.occHis;
              that.symptom = resp.data.occSym;
              let i;
              if (
                that.occupatHistArr != null &&
                that.occupatHistArr.length > 0
              ) {
                for (i in that.occupatHistArr) {
                  that.occupatHistArr[i].startDate = that.occupatHistArr[
                    i
                  ].startDate.substring(0, 10);
                  this.occupatHistArr[i].endDate = that.occupatHistArr[
                    i
                  ].endDate.substring(0, 10);
                }
              }
            }
          } else {
            Toast.fail(resp.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //关闭添加框组件
    closeFun() {
      const that = this;
      that.showUserAdd = false;
    },
    //获取维护的用户
    gainUser() {
      const that = this;
      that.list = [];
      getUser({ openId: sessionStorage.getItem("openid") })
        .then((resp) => {
          if (resp.code === 200) {
            that.list = resp.data ? resp.data : [];
            if (that.list && that.list.length > 0) {
              that.userInfo = that.list[0];
            }
            sessionStorage.setItem(
              "userIsBang",
              that.list.length > 0 ? "yes" : "no"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.newGroup {
  margin: 0.1rem 0;
}

.newCell {
  padding: 0 0.32rem !important;
}

.newCell2 {
  min-height: 0.84rem;
  padding-top: 0;
}

.newButton {
  width: 1.5rem;
  position: absolute;
  right: 0.32rem;
}

.leftG {
  right: 1.9rem;
}

.display1 {
  display: none;
}
</style>
